import { fieldLimits } from "config";
import React, { type ChangeEvent } from "react";

import type { EntityFieldConfig } from "./entityForms.types";

import styles from "./formDialog.module.css";

type FormFieldProps = {
	field: EntityFieldConfig;
	idPrefix: string;
	label: string;
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	value: string;
};

/** A config-driven text input for the generic entity form, with optional datalist suggestions. */
const FormField = ({ field, idPrefix, label, onChange, value }: FormFieldProps) => {
	const inputId = `${idPrefix}-${field.key}`;
	const listId = field.suggestions ? `${inputId}-suggestions` : undefined;
	const className = field.fullWidth
		? `${styles.personFormField} ${styles.personFormFieldFull}`
		: styles.personFormField;

	return (
		<div className={className}>
			<label htmlFor={inputId}>{label}</label>
			<input
				id={inputId}
				list={listId}
				maxLength={fieldLimits.customPropertyValue}
				name={field.key}
				onChange={onChange}
				type="text"
				value={value}
			/>
			{field.suggestions && (
				<datalist id={listId}>
					{field.suggestions.map((suggestion: string) => (
						<option key={suggestion} label={suggestion} value={suggestion} />
					))}
				</datalist>
			)}
		</div>
	);
};

export default FormField;
